import { Trans } from "@lingui/react/macro";
import React from "react";
import { Spinner } from "../presentation/Spinner";
import { Well } from "react-bootstrap";
import { Link } from "react-router";
import HiveWatchBanner from "../presentation/HiveWatchBanner";

const getBanner = (type) => {
  switch (type) {
    case "spinner":
      // Auto margins, not text-align: the Well shim's card-body is a flex
      // column, so the spinner is a flex item that otherwise pins left.
      return <Spinner style={{ marginLeft: "auto", marginRight: "auto" }} />;
    case "logo":
      return <HiveWatchBanner />;
    default:
    case "none":
      return "";
  }
};

export const BigMessageView = ({ banner, title, text }) => (
  <Well style={{ textAlign: "center", marginTop: "20%" }}>
    {getBanner(banner)}
    <h3>{title || <Trans id="error">Fehler</Trans>}</h3>
    <div>{text}</div>
  </Well>
);

export const NotFoundView = () => (
  <BigMessageView
    title="404"
    banner="logo"
    text={
      <Trans id="base.pagenotfound">
        <p>
          Diese Seite existiert nicht. <Link to="/">Hier</Link> kommen Sie
          zurück zur Startseite.
        </p>
      </Trans>
    }
  />
);

//TODO with react 16, let's put an error boundary here and indicate if the page load crashed
export const LoadingView = ({ children = "Loading..." }) => (
  <BigMessageView banner="logo" title={children} />
);
